/**
 * 功能: 竖版报告预览组件
 */
<template lang="pug">
  div
    div(:id ="'a' + data._id" style="padding-top:150px; margin-top: -100px; text-align: center" v-if="!data.parent")
      p(style='font-size:x-large;font-weight:bold') {{ data.name }}
    div(style="line-height: 2; margin:10px 0;" v-else)
      div(style="font-size:14px")
        p(:id ="'a' + data._id" style="padding-top:65px; margin-top: -65px;font-size:larger;font-weight:bold") {{ data.wbs }}  {{data.name}}
          i(class="el-icon-info" @click="showMemoDialog" v-if="data.internalMemo")
          memoDialog(ref="memoDialog" :isDisabled="true" :relativeId="data._id")
      div(v-if="data.isGlossary")
        div(v-for="glossary in glossaryArrs" style="position:relative;margin:20px")
          p.glossary {{glossary.noun}}—{{glossary.explanation}}
      Section(:data="data")
    template(v-for="child in data.children")
      Content(:key="child.title" :data="child")
</template>

<script>
import Section from './section'
import memoDialog from '@/components/dialog'
export default {
  name: 'Content',
  props: {
    data: {
      type: Object
    }
  },
  components: {
    Section, memoDialog
  },
  data () {
    return {
      glossaryArrs: [],
      totalText: 0
    }
  },
  mounted () {
    this.glossaryArrs = JSON.parse(sessionStorage.getItem('GLOSSARY'))
  },
  methods: {
    showMemoDialog () {
      this.$refs.memoDialog.show()
    }
  }
}
</script>

<style scoped>
.glossary{
  text-indent: 2em;
  font-size: 14px;
}
.el-icon-info:hover{
  cursor: pointer;
}
</style>
